import { Mapper } from "../../../../base/utils/mapper";
import { CountryModel } from "../../../../domain/models/configuration/country.model";
import { CountryEntity } from "../entities/country.entity";


export class CountryImplementationRepositoryMapper extends Mapper<CountryEntity, CountryModel> {
    mapFrom(param: CountryEntity): CountryModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: CountryModel): CountryEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}